[
  {
    "id": "KIT_001",
    "nome": "Kit Dia Leve",
    "composicao": [
      "1 almoço",
      "1 jantar leve, sopa ou creme",
      "1 snack saudável",
      "1 suco natural ou detox"
    ],
    "usoRecomendado": "Cliente que quer resolver um dia completo.",
    "faixaCaloricaEstimada": "900 a 1300 kcal",
    "guardrails": [],
    "segmentosAlvo": [
      "cliente-novo",
      "cliente-recorrente"
    ],
    "ctaSugerido": "Quer resolver o dia completo? Posso montar um Kit Dia Leve para você!"
  },
  {
    "id": "KIT_002",
    "nome": "Kit Dia Controle",
    "composicao": [
      "1 marmita equilibrada",
      "1 opção leve ou low carb",
      "1 snack saudável",
      "Registro calórico automático"
    ],
    "usoRecomendado": "Cliente interessado em organização de consumo.",
    "faixaCaloricaEstimada": "800 a 1100 kcal",
    "guardrails": [
      "G02"
    ],
    "segmentosAlvo": [
      "cliente-recorrente",
      "cliente-fiel"
    ],
    "ctaSugerido": "Posso montar um kit equilibrado com registro calórico informativo. Tem interesse?"
  },
  {
    "id": "KIT_003",
    "nome": "Kit Dia Performance",
    "composicao": [
      "1 marmita com maior proteína",
      "1 jantar equilibrado",
      "1 snack fit",
      "1 suco natural"
    ],
    "usoRecomendado": "Cliente com rotina intensa.",
    "faixaCaloricaEstimada": "1200 a 1700 kcal",
    "guardrails": [
      "G02"
    ],
    "segmentosAlvo": [
      "cliente-recorrente",
      "cliente-fiel",
      "cliente-alto-valor"
    ],
    "ctaSugerido": "Para uma rotina mais intensa, o Kit Dia Performance pode ser ideal!"
  },
  {
    "id": "KIT_004",
    "nome": "Semana Econômica",
    "composicao": [
      "5 almoços",
      "Registro calórico automático",
      "Upsell opcional de snacks e sucos"
    ],
    "usoRecomendado": "Cliente novo ou baixo ticket.",
    "faixaCaloricaEstimada": null,
    "guardrails": [],
    "segmentosAlvo": [
      "cliente-novo",
      "cliente-baixo-ticket"
    ],
    "ctaSugerido": "Que tal resolver os almoços da semana de forma prática e econômica?"
  },
  {
    "id": "KIT_005",
    "nome": "Semana Útil Resolvida",
    "composicao": [
      "5 almoços",
      "5 jantares",
      "5 snacks",
      "5 bebidas",
      "Registro automático 5 dias"
    ],
    "usoRecomendado": "Cliente recorrente ou fiel.",
    "faixaCaloricaEstimada": null,
    "guardrails": [],
    "segmentosAlvo": [
      "cliente-recorrente",
      "cliente-fiel"
    ],
    "ctaSugerido": "Posso montar sua semana: almoço, jantar, snack e bebida para os 5 dias. Quer?"
  },
  {
    "id": "KIT_006",
    "nome": "Semana Completa Rê Leve",
    "composicao": [
      "7 almoços",
      "7 jantares",
      "7 snacks",
      "7 bebidas",
      "3 a 7 sobremesas saudáveis",
      "Registro automático 7 dias"
    ],
    "usoRecomendado": "Cliente fiel, alto valor ou família.",
    "faixaCaloricaEstimada": null,
    "guardrails": [
      "G09"
    ],
    "segmentosAlvo": [
      "cliente-fiel",
      "cliente-alto-valor",
      "possivel-coletivo"
    ],
    "ctaSugerido": "Semana 100% resolvida com a Rê Leve! 7 dias completos. Quer montar?"
  },
  {
    "id": "KIT_007",
    "nome": "Família Organizada",
    "composicao": [
      "20 a 30 marmitas",
      "5 a 10 snacks",
      "5 a 10 bebidas"
    ],
    "usoRecomendado": "Pedido alto ou família.",
    "faixaCaloricaEstimada": null,
    "guardrails": [
      "G09"
    ],
    "segmentosAlvo": [
      "possivel-coletivo",
      "cliente-alto-valor"
    ],
    "ctaSugerido": "Para organizar a alimentação da família, posso montar um kit especial. É para quantas pessoas?"
  },
  {
    "id": "KIT_008",
    "nome": "Escritório Saudável",
    "composicao": [
      "10, 20 ou 30 refeições",
      "snacks coletivos",
      "bebidas",
      "entrega programada"
    ],
    "usoRecomendado": "Compra coletiva ou equipe.",
    "faixaCaloricaEstimada": null,
    "guardrails": [
      "G09",
      "G10"
    ],
    "segmentosAlvo": [
      "possivel-coletivo"
    ],
    "ctaSugerido": "Para alimentação de equipe, temos condições especiais. Posso encaminhar para nosso atendimento comercial?"
  }
]